// extracted by mini-css-extract-plugin
module.exports = {"entityLink":"cKMGuoMf"};